<script setup lang="ts">
interface HeadlineProps {
  headline?: string | null;
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
}

withDefaults(defineProps<HeadlineProps>(), {
  as: 'h2',
});
</script>

<template>
  <component
    :is="as"
    v-if="headline"
    :class="`font-heading text-foreground font-normal text-2xl md:text-3xl lg:text-headline`"
  >
    {{ headline }}
  </component>
</template>
